import { render, staticRenderFns } from "./ContentLoading.vue?vue&type=template&id=3d5855ac&scoped=true&"
import script from "./ContentLoading.vue?vue&type=script&lang=js&"
export * from "./ContentLoading.vue?vue&type=script&lang=js&"
import style0 from "./ContentLoading.vue?vue&type=style&index=0&id=3d5855ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5855ac",
  null
  
)

export default component.exports